export default function toggleElement() {
  document.querySelectorAll('a.toggle-element').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const selector = link.getAttribute('href');
      const element = document.querySelector(selector);
      element.classList.toggle('hidden');
      if (element.getAttribute('aria-hidden') == 'true') {
        element.setAttribute('aria-hidden', 'false');
      } else {
        element.setAttribute('aria-hidden', 'true');
      }
    });
  });
}
